import { Text } from 'dripsy';
import * as React from 'react';
export const AutocompleteItemLabel = ({ label, keyword, }) => {
    if (keyword) {
        const searchIndex = label.toLowerCase().indexOf(keyword.toLowerCase());
        if (searchIndex !== -1) {
            return (React.createElement(React.Fragment, null,
                searchIndex > 0 && label.substring(0, searchIndex),
                React.createElement(Text, { sx: { fontWeight: 'bold' } }, label.substring(searchIndex, searchIndex + keyword.length)),
                label.substring(searchIndex + keyword.length)));
        }
    }
    return React.createElement(React.Fragment, null, label);
};
//# sourceMappingURL=AutocompleteItemLabel.js.map